<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix m-b-5">
      <h3 class="pull-left m-v-0" v-if="!$isEmpty($query)">
        <span v-if="school&&school.name">{{school.name}} -</span>
        <span v-if="teacher&&teacher.name">{{teacher.name}} -</span>
        班级列表
      </h3>
      <div class="pull-right">
        <el-input placeholder="搜索班级" class="m-r-10 max-width-200 w-a"
                  suffix-icon="el-icon-search" v-model="search"></el-input>
        <router-link v-if="$location.admin_group_edit.auth()"
                     :to="$location.admin_group_edit()" class="el-button el-button--primary">创建班级
        </router-link>
        <router-link v-if="$location.admin_student_batch_import.auth()"
                     :to="$location.admin_student_batch_import()" class="el-button el-button--primary">批量导入
        </router-link>
        <el-button type="default" @click="$router.back()" v-if="!$isEmpty($query)">返回</el-button>
      </div>
    </div>
    <el-table :data="page" border>
      <template slot="empty">
        <div v-if="ready">
          <div v-if="!list.length">暂无数据</div>
          <div v-else-if="!filtered.length">无匹配结果</div>
        </div>
      </template>
      <el-table-column label="班级" prop="name" label-class-name="no-selectable c-p"
                       sortable sort-by="$$pinyin.name.full">
        <template slot-scope="scope">
          <span v-html="$highlight(scope.row.name, scope.row.$$pinyin.name)"></span>
        </template>
      </el-table-column>
      <el-table-column label="学段" prop="grade" sortable label-class-name="no-selectable c-p">
        <template slot-scope="scope">
          <span v-html="$highlight(scope.row.grade, scope.row.$$pinyin.grade)"></span>
        </template>
      </el-table-column>
      <el-table-column label="入学年份" prop="year" sortable label-class-name="no-selectable c-p"></el-table-column>
      <el-table-column label="创建时间" prop="time_create" sortable
                       label-class-name="no-selectable c-p">
        <template slot-scope="scope">{{scope.row.time_create | sub(0, -3)}}</template>
      </el-table-column>
      <el-table-column label="查看" align="center" v-if="$location.admin_student.auth()">
        <template slot-scope="scope">
          <router-link :to="$location.admin_student({group_uid: scope.row.uid})"
                       class="el-button el-button--mini el-button--primary">学生
          </router-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <router-link :to="$location.admin_group_edit({group_uid: scope.row.uid})"
                       class="el-button el-button--mini el-button--warning">
            编辑
          </router-link>
          <router-link :to="$location.admin_student_batch_import({group_uid: scope.row.uid})"
                       class="el-button el-button--mini el-button--warning">批量导入
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filtered.length>pageInfo.page" :total="filtered.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
  </div>
</template>

<script>
import * as Group from 'api/group'
import * as School from 'api/school'
import * as Teacher from 'api/teacher'
import page from 'utils/page'

export default {
  data () {
    return {
      ready: false,
      list: [],
      school: null,
      teacher: null,
      pageInfo: {page: 10, current: 1},
      search: '',
    }
  },
  computed: {
    filtered () {
      return this.$search(this.list, this.search, ['name', 'year'])
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let query = this.$query
        let [list, school, teacher] = await Promise.all([
          Group.list(query),
          query.school_uid ? School.get(query) : null,
          query.user_uid ? Teacher.get(query) : null,
        ])
        this.list = list
        this.school = school
        this.teacher = teacher
        this.ready = true
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/group/GroupList.vue